module.exports = __webpack_public_path__ + "static/media/หนังสือขอบคุณ.0d4b5ed5.pdf";